import React, { useContext } from 'react';
import { calculateFontSize, fetchCurrency, getConfig, restrictDecimalPlaces } from 'utils/helperMethods';
import SelectionDropDown from '../SelectionDropDown';
import _ from 'lodash';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import { UserContext } from 'contexts/ConfigContext';
import Loader from '../Loader';
import { notification } from 'antd';
import { limitMessage } from 'components/atoms/PromoRecommendation/LowerLevelSection';
import {
    PROMO_RECOMMENDATION_ADD_EVENT_BASELINE_VOLUME_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_DROPDOWN_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_INPUT_CHANGED,
    PROMO_RECOMMENDATION_ADD_EVENT_UPLIFT_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_BASELINE_VOLUME_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_DROPDOWN_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_INPUT_CHANGED,
    PROMO_RECOMMENDATION_EDIT_EVENT_UPLIFT_CHANGED,
} from 'utils/mixpanelEventNames';
import { trackEventMixpanel } from 'utils/mixpanel';

const extraFields = [{ value: 'promoSpends', label: 'Total Spends ($)', placeholder: 'Total Spends' }];

const scaledWidth = calculateFontSize(window.innerWidth, 200);
export const scaledHeight = calculateFontSize(window.innerHeight, 250);

const mixpanelMapping: any = {
    baseVolume: [
        PROMO_RECOMMENDATION_ADD_EVENT_BASELINE_VOLUME_CHANGED,
        PROMO_RECOMMENDATION_EDIT_EVENT_BASELINE_VOLUME_CHANGED,
    ],
    uplift: [PROMO_RECOMMENDATION_ADD_EVENT_UPLIFT_CHANGED, PROMO_RECOMMENDATION_EDIT_EVENT_UPLIFT_CHANGED],
};

function AddEditSpends() {
    const {
        addSpends,
        setAddSpends,
        editMode: edit,
        spendType,
        setSpendType,
        editOriginalData,
        modelRecommendedData,
        additionalKpiLoading,
        baselineUpliftLoading,
        baselineLoading,
        checkIfDataPresentAndFetchData,
    } = useContext(promoRecommendation);

    const { appConfig } = useContext(UserContext);
    const { spendLabel, spendTypeList, clientName, spendLeversList } = getConfig('promoRecommendation', appConfig);
    const currencySymbol = fetchCurrency(appConfig);

    const perQty = [
        { value: 'spends', label: `Spends (${currencySymbol})`, placeholder: 'Spends' },
        { value: 'redemption', label: 'Redemption (%)', placeholder: 'Redemption' },
        // { value: 'scanRate', label: 'Scan Rate' },
    ];

    function deleteOnUncheck(value: any, obj: any) {
        if (value == 'per_qty') {
            perQty.forEach((data) => {
                delete obj['per_qty'][data.value];
            });
            spendTypeList;
        } else {
            delete obj[value];
        }
        return obj;
    }

    function onClickCheckBoxOfSpendType(setSpendType: any, e: any, selectedData: any) {
        trackEventMixpanel(
            edit
                ? PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_DROPDOWN_CHANGED
                : PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_DROPDOWN_CHANGED,
            {
                dropdownValue: selectedData?.label,
                isChecked: e.target.checked,
            },
        );
        setSpendType((oldData: any) => {
            let data = _.cloneDeep(oldData);
            if (e.target.checked) {
                data.push(selectedData.value);
                setAddSpends((oldData: any) => {
                    let cloneDeep = _.cloneDeep(oldData);
                    cloneDeep['per_qty'] = { redemption: '', spends: '' };
                    return cloneDeep;
                });
                return data;
            } else {
                let filteredList = data.filter((data: any) => data !== selectedData.value);
                setAddSpends((oldData: any) => {
                    let cloneDeep = _.cloneDeep(oldData);
                    cloneDeep = deleteOnUncheck(selectedData.value, cloneDeep);
                    return cloneDeep;
                });
                return filteredList;
            }
        });
    }

    //onChange function for form
    function changeInputForm(e: any, item: any, type = 'int') {
        if (type === 'float' && restrictDecimalPlaces(e.target.value, 2)) return;
        setAddSpends((oldData: any) => {
            let cloneDeep = _.cloneDeep(oldData);
            const parsedValue = type == 'int' ? parseInt(e.target.value) : _.round(parseFloat(e.target.value), 2);
            cloneDeep[item.value] = parsedValue;
            if (item.value === 'baseVolume' && _.isFinite(oldData?.uplift)) {
                cloneDeep['totalVolume'] = _.round(parsedValue * oldData.uplift, 2);
            } else if (item.value === 'uplift' && _.isFinite(oldData?.baseVolume)) {
                cloneDeep['totalVolume'] = _.round(parsedValue * oldData.baseVolume, 2);
            }
            checkIfDataPresentAndFetchData(cloneDeep);
            return cloneDeep;
        });
    }

    function changeSpendType(e: any, item: any, type = 'int') {
        if (item === 'redemption') {
            if (parseInt(e.target.value) > 100 || parseInt(e.target.value) < 0 || e.target.value == '-') {
                notification.open({
                    message: limitMessage,
                    className: 'custom-class',
                    style: {
                        width: 350,
                        height: 70,
                    },
                });
                return;
            }
        }
        if (type === 'float' && restrictDecimalPlaces(e.target.value, 2)) return;
        setAddSpends((oldData: any) => {
            let cloneDeep = _.cloneDeep(oldData);
            cloneDeep['per_qty'][item] =
                type === 'int' ? parseInt(e.target.value) : _.round(parseFloat(e.target.value), 2);
            checkIfDataPresentAndFetchData(cloneDeep);
            return cloneDeep;
        });
    }

    return (
        <div className="flex flex-col px-4  w-full">
            <span className="font-lg font-medium">{edit ? 'Edit Spends' : 'Add Spends'}</span>
            {/* Lever form */}
            <div
                style={{ height: scaledHeight + 40 }}
                className="border-collapse border border-borderGrey mt-2 rounded-t text-purpleFont overflow-auto"
            >
                <div className="flex w-full justify-between bg-bgBackground border-b-1 border-borderGrey rounded font-medium sticky top-0  z-[100]">
                    <div className="flex w-full">
                        <div className="flex py-2 pl-2">
                            <span>Levers</span>
                        </div>
                    </div>
                    {edit && (
                        <div className="flex w-full ">
                            <div className="flex py-2 pl-2 justify-start items-center w-full">
                                <span>Original</span>
                            </div>
                        </div>
                    )}
                    <div className="flex w-full">
                        <div className="flex py-2 pl-2 justify-center w-full">
                            <span>Modified</span>
                        </div>
                    </div>
                </div>
                <div className="flex w-full justify-between flex-col">
                    {spendLeversList?.map((data: any, idx: number) => {
                        const recommendedValue =
                            modelRecommendedData?.[idx] === undefined ? null : modelRecommendedData?.[idx]?.value;
                        return (
                            <div className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-2 !text-fontGray">
                                <div className="font-xxs !text-fontGray w-28 min-w-40 font-medium">{data.label}</div>
                                {edit && (
                                    <div className="font-xxs !text-fontGray">
                                        {data.value in editOriginalData
                                            ? Number(editOriginalData[data.value])?.toLocaleString()
                                            : ''}
                                    </div>
                                )}
                                <div className="flex flex-col">
                                    <span className="border border-purpleFont rounded">
                                        <input
                                            onWheel={(e) => e.currentTarget?.blur()}
                                            disabled={data.isDisabled}
                                            className="m-0.5 focus:outline-none"
                                            style={{ width: scaledWidth - 8 }}
                                            onChange={(e) => {
                                                changeInputForm(e, data, 'float');
                                                if (edit) {
                                                    trackEventMixpanel(mixpanelMapping?.[data?.value]?.[1], {
                                                        modifiedValue: e.target.value,
                                                        originalValue:
                                                            Number(editOriginalData?.[data?.value])?.toLocaleString() ||
                                                            '',
                                                    });
                                                } else {
                                                    trackEventMixpanel(mixpanelMapping?.[data?.value]?.[0], {
                                                        inputValue: e.target.value,
                                                    });
                                                }
                                            }}
                                            value={data.value in addSpends ? addSpends[data.value] : ''}
                                            placeholder={`Enter ${data.placeholder}`}
                                            type="number"
                                            step="0.01"
                                        />
                                    </span>
                                    {(recommendedValue !== null ||
                                        (additionalKpiLoading && idx > 2) ||
                                        (baselineUpliftLoading && idx <= 2) ||
                                        (baselineLoading && idx <= 2)) && (
                                        <span className="text-fontGreyAlt font-xxs">
                                            <span className="mr-2">Model Recommended: </span>
                                            {(additionalKpiLoading && idx > 2) ||
                                            (baselineUpliftLoading && idx <= 2) ||
                                            (baselineLoading && idx <= 2) ? (
                                                <Loader size={'small'} style={{ display: 'contents' }} />
                                            ) : (
                                                recommendedValue
                                            )}
                                        </span>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div
                className="border-collapse border border-borderGrey mt-4 rounded overflow-auto"
                style={{ height: scaledHeight + 60 }}
            >
                <div className="flex w-full justify-between bg-bgBackground border-0 border-b border-borderLinePurpuleAlt rounded-t text-purpleFont font-medium sticky top-0 z-[100]">
                    <div className="flex w-full">
                        <div className="flex py-2 pl-2">
                            <span>Spends Type</span>
                        </div>
                    </div>
                    {edit && (
                        <div className="flex w-full ">
                            <div className="flex py-2 pl-2 justify-start items-center w-full">
                                <span>Original</span>
                            </div>
                        </div>
                    )}
                    <div className="flex w-full">
                        <div className="flex py-2 pl-2 justify-center w-full">
                            <span>Modified</span>
                        </div>
                    </div>
                </div>
                {/* Spend data */}
                <div className="flex flex-col justify-between w-full items-center h-full">
                    <div className="flex justify-between w-full items-center p-2">
                        <span className="font-xs font-medium">Spends</span>
                        <SelectionDropDown
                            list={spendTypeList}
                            checkedListObject={spendType}
                            customOnChange={onClickCheckBoxOfSpendType}
                            disabled={false}
                            setSelectedList={setSpendType}
                            selectedList={spendType}
                            selectAll={false}
                            style={{ width: scaledWidth }}
                        />
                    </div>
                    <div className="flex w-full flex-col h-full">
                        {renderForm(
                            spendType,
                            edit,
                            changeInputForm,
                            addSpends,
                            changeSpendType,
                            spendLabel,
                            editOriginalData,
                            currencySymbol,
                            perQty,
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function renderForm(
    spendType: any,
    edit: boolean,
    changeInputForm: Function,
    addSpends: any,
    changeSpendType: Function,
    spendLabel: any,
    editOriginalData: any,
    currencySymbol: any,
    perQty: any[],
) {
    let hideTotalSpends = true;
    return spendType.length ? (
        <>
            {spendType?.map((data: any) => {
                // if (
                //     (data === 'per_qty' && Object.keys(addSpends[data]).length) ||
                //     (data in addSpends && data !== 'promoSpends')
                // ) {
                //     console.log(addSpends, 'logging dat');
                //     hideTotalSpends = false;
                // }
                if (data == 'per_qty') {
                    return (
                        <div
                            className="flex flex-col justify-between w-full border-solid border-0 border-t border-borderLinePurpuleAlt p-2 "
                            key={data}
                        >
                            <span className="font-xs font-medium mb-2">{spendLabel[data]}</span>
                            <div className="flex flex-col gap-2">
                                {perQty?.map((data) => {
                                    return (
                                        <div className="flex w-full justify-between items-center">
                                            <span className="font-xxs !text-fontGray w-28 min-w-40">{data.label}</span>
                                            {edit && (
                                                <span className="font-xxs !text-fontGray">
                                                    {data.value in editOriginalData['per_qty']
                                                        ? Number(
                                                              editOriginalData['per_qty'][data.value],
                                                          )?.toLocaleString()
                                                        : ''}
                                                </span>
                                            )}
                                            <span className="border border-purpleFont rounded flex">
                                                <input
                                                    onWheel={(e) => e.currentTarget?.blur()}
                                                    className="m-0.5 focus:outline-none"
                                                    style={{ width: scaledWidth - 8 }}
                                                    onChange={(e) => {
                                                        changeSpendType(
                                                            e,
                                                            data.value,
                                                            data.value === 'spends' ? 'float' : 'int',
                                                        );
                                                        if (edit) {
                                                            trackEventMixpanel(
                                                                PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_INPUT_CHANGED,
                                                                {
                                                                    originalValue:
                                                                        Number(
                                                                            editOriginalData['per_qty'][data.value],
                                                                        )?.toLocaleString() || '',
                                                                    modifiedValue: e.target.value,
                                                                    spendsType: 'Per Qty',
                                                                },
                                                            );
                                                        } else {
                                                            trackEventMixpanel(
                                                                PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_INPUT_CHANGED,
                                                                {
                                                                    inputValue: e.target.value,
                                                                    spendsType: 'Per Qty',
                                                                },
                                                            );
                                                        }
                                                    }}
                                                    value={
                                                        data.value in addSpends['per_qty']
                                                            ? addSpends['per_qty'][data.value]
                                                            : ''
                                                    }
                                                    placeholder={`Enter ${data.placeholder}`}
                                                    type="number"
                                                />
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                } else if (data in spendLabel) {
                    return (
                        <div
                            className="flex flex-col justify-between w-full border-solid border-0 border-t border-borderLinePurpuleAlt p-2 "
                            key={data}
                        >
                            <span className="font-xs font-medium mb-2">{spendLabel[data]}</span>
                            <div className="flex w-full justify-between items-center">
                                <span className="font-xxs !text-fontGray w-28 min-w-40">{`Spends (${currencySymbol})`}</span>
                                {edit && (
                                    <span className="font-xxs !text-fontGray">
                                        {data in editOriginalData
                                            ? Number(editOriginalData[data])?.toLocaleString()
                                            : ''}
                                    </span>
                                )}
                                <span className="border border-purpleFont rounded flex">
                                    <input
                                        onWheel={(e) => e.currentTarget?.blur()}
                                        className="m-0.5 focus:outline-none"
                                        style={{ width: scaledWidth - 8 }}
                                        onChange={(e) => {
                                            changeInputForm(e, { value: data }, 'float');
                                            if (edit) {
                                                trackEventMixpanel(
                                                    PROMO_RECOMMENDATION_EDIT_EVENT_SPENDS_INPUT_CHANGED,
                                                    {
                                                        originalValue:
                                                            Number(editOriginalData?.[data])?.toLocaleString() || '',
                                                        modifiedValue: e.target.value,
                                                        spendsType: _.startCase(data),
                                                    },
                                                );
                                            } else {
                                                trackEventMixpanel(
                                                    PROMO_RECOMMENDATION_ADD_EVENT_SPENDS_INPUT_CHANGED,
                                                    {
                                                        inputValue: e.target.value,
                                                        spendsType: _.startCase(data),
                                                    },
                                                );
                                            }
                                        }}
                                        value={addSpends[data]}
                                        placeholder="Enter Spends"
                                        type="number"
                                    />
                                </span>
                            </div>
                        </div>
                    );
                }
            })}
            {/* <div className="flex flex-col justify-between w-full border-solid border-0 border-t border-borderLinePurpuleAlt p-2 ">
                <div className="flex w-full justify-between items-center">
                    <span className="font-xxs !text-fontGray w-28 min-w-40">{extraFields[0].label}</span>
                    {edit && (
                        <span className="font-xxs !text-fontGray">
                            {extraFields[0].value in editOriginalData
                                ? Number(editOriginalData[extraFields[0].value])?.toLocaleString()
                                : ''}
                        </span>
                    )}
                    <span className="border border-purpleFont rounded flex">
                        <input
                            disabled
                            onWheel={(e) => e.currentTarget?.blur()}
                            className="m-0.5 focus:outline-none"
                            style={{ width: scaledWidth - 8 }}
                            onChange={(e) => changeInputForm(e, { value: extraFields[0].value }, 'float')}
                            value={hideTotalSpends ? null : addSpends[extraFields[0].value]}
                            placeholder={extraFields[0]?.placeholder}
                            type="number"
                        />
                    </span>
                </div>
            </div> */}
        </>
    ) : (
        <div className="flex h-full w-full justify-center items-center">
            <span>Add spend types from the dropdown</span>
        </div>
    );
}

export default AddEditSpends;
